import { createAction } from 'redux-actions';
import { SET_APP_MODE } from '../../constants';

export const setAppMode = createAction(SET_APP_MODE, (mode) => mode);
